'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'select2';
import { stateCity, area, unity, funcional, habilities } from '../../modules/select';
import passRules from '../../modules/passRules';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_error_attention: 'Atenção!',
    modal_error_fields: 'Preencha os campos corretamente!',
    modal_error_pass: 'Preencha uma senha válida!',
    modal_error_captcha: 'Você deve marcar o captcha para continuar!',
    modal_error_terms: 'Você deve aceitar os termos para continuar!',
  },
  en: {
    modal_error_attention: 'Attention!',
    modal_error_fields: 'Enter the fields correctly!',
    modal_error_pass: 'Preencha uma senha valid!',
    modal_error_captcha: 'You must mark the captcha to continue!',
    modal_error_terms: 'You must oil the thermos to continue!',
  },
  es: {
    modal_error_attention: '¡Atención!',
    modal_error_fields: '¡Preencha los campos correctamente!',
    modal_error_pass: '¡Preencha uma senha válida!',
    modal_error_captcha: '¡Debes marcar el captcha para continuar!',
    modal_error_terms: '¡Você deve aceitar os termos para continuar!',
  },
};

const showRegistrationForm = {
  settings: {
    $selectState: $('.js-state-filter'),
    $selectCity: $('.js-cities'),
    $selectInvitedBy: $('#who_invited'),
    $selectHabilities: $('.js-habilities'),
    $selectUnity: $('.js-unity'),
    $selectArea: $('.js-areas'),
    $selectFuncional: $('.js-funcional'),
    $areaOther: $('[name="area_other"]'),
    $unityOther: $('[name="unity_other"]'),
  },

  initSelect() {
    stateCity();
    area();
    unity();
    funcional();
    habilities();
  },

  nextStep() {
    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (currentSlide == 'first') {
        if (
          $("input[name='cpf']").val().length < 14 ||
          $("input[name='name']").val() == '' ||
          $("input[name='cpf']").hasClass('is-invalid')
        ) {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
          return false;
        }
      }

      if (currentSlide === 'state') {
        if (s.$selectState.val() === '' || s.$selectCity.val() === '') {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');

          return false;
        }

        if ($("input[name='volunteer_type']:checked").val() == 'external') {
          nextSlide = 'password';
        } else {
          nextSlide = 'rede';
        }
      }

      if (currentSlide === 'rede') {
        if (
          s.$selectArea.val() === '' ||
          s.$selectUnity.val() === '' ||
          (s.$areaOther.is(':visible') && s.$areaOther.val() == '') ||
          (s.$unityOther.is(':visible') && s.$unityOther.val() == '')
        ) {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
          return false;
        }
      }

      if (currentSlide === 'contact') {
        if ($('[name="email"]').val() == '' || $('[name="entry_date"]').val() === '' || $('[name="entry_date"]').val().length <= 9) {
          Swal.fire(tr[lang].modal_error_attention, 'Preencha os campos corretamente!', 'error');
          return false;
        }
      }

      if (currentSlide === 'habilities') {
        if (s.$selectHabilities.val() === '') {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_fields, 'error');
          return false;
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });
  },

  prevStep() {
    $('.back').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (nextSlide == 'rede') {
        if (
          $("input[name='volunteer_type']:checked").val() == 'external' ||
          $("input[name='volunteer_type']:checked").val() == 'provider'
        ) {
          nextSlide = 'state';
        } else {
          nextSlide = 'rede';
        }
      }

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });
  },

  bindActions() {
    $('input[name="volunteer_type"]').on('change', function () {
      $('.js-form-email').attr('placeholder', '');
      $('#area').hide();
      $('#who_invited_block').hide();
    });

    $('.js-rede').on('change', function () {
      if ($("input[name='is_rede']:checked").val() == '1') {
        $('#is_rede_options').removeClass('u-display--none');
        $('#is_regional_options').removeClass('u-display--none');
      } else {
        $('#is_rede_options').addClass('u-display--none');
        $('#is_regional_options').addClass('u-display--none');
      }
    });

    $('.js-form-cpf').on('change keyup paste', function (e) {
      e.preventDefault();

      var cpf = $(this).val();
      if (cpf != '') {
        var validacpf = /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/;

        if (validacpf.test(cpf)) {
          getCpf(cpf);
        } else {
          $('#cpf-error').text('');
        }
      }
    });

    function getCpf(cpf) {
      var url = '/check-cpf/' + cpf;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#cpf-error').text(response.message);
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    $('.js-form-email').on('change keyup paste', function (e) {
      e.preventDefault();

      var email = $(this).val();
      if (email != '') {
        getEmail(email);
      }
    });

    function getEmail(email) {
      var url = '/check-email/' + email;

      $.ajax({
        type: 'get',
        url: url,
        dataType: 'json',
        data: {},
        success: function (response) {
          if (!response.success) {
            $('#email-error').text(response.message);
          } else {
            $('#email-error').text('');
          }
        },
        error: function (jqXHR, status, error) {
          console.log(error);
        },
      });
    }

    $(document).on('click', '#btn-register', function (e) {
      e.preventDefault();

      if (!passRules.settings.submit) {
        Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_pass, 'error');
      } else {
        let checkLength = $('.js-check').length;

        if ($('.js-check:checked').length === checkLength) {
          let v = grecaptcha.getResponse();
          if (v.length !== 0) {
            $('#form-signin').submit();
          } else {
            Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_captcha, 'error');
          }
        } else {
          Swal.fire(tr[lang].modal_error_attention, tr[lang].modal_error_terms, 'error');
        }
      }
    });
  },

  init() {
    passRules.init();
    _this.initSelect();
    _this.nextStep();
    _this.prevStep();
    _this.bindActions();
  },
};

const s = showRegistrationForm.settings,
  _this = showRegistrationForm;

export default _this;
